import { CheckSquare, BookOpen, Home, Building2, Users, Key } from "lucide-react"
import { useTranslation } from 'react-i18next'

const useCaseIcons = [
  <CheckSquare size={20} className="text-green-600" />,
  <BookOpen size={20} className="text-green-600" />,
  <Home size={20} className="text-green-600" />,
  <Building2 size={20} className="text-green-600" />,
  <Users size={20} className="text-green-600" />,
  <Key size={20} className="text-green-600" />,
]

interface UseCase {
  title: string
  description: string
}

export default function UseCasesSection() {
  const { t } = useTranslation()

  const items = t('landing.useCases.items', { returnObjects: true }) as UseCase[]

  return (
    <section id="use-cases" className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p
            className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            {t('landing.useCases.sectionLabel')}
          </p>
          <h2
            className="text-3xl sm:text-4xl font-bold text-green-600 dark:text-green-400"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            {t('landing.useCases.headline')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-10">
          {items.map((useCase, i) => (
            <div key={useCase.title} className="flex gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-green-100 dark:bg-green-900/40 rounded-lg flex items-center justify-center">
                {useCaseIcons[i]}
              </div>
              <div>
                <h3
                  className="text-base font-bold text-gray-900 dark:text-white mb-1"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {useCase.title}
                </h3>
                <p
                  className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {useCase.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
